import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../../core/services/login.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StorageService } from '../../core/services/storage.service';
import { AssessmentService } from '../../core/services/assessment.service';
import { CommonService } from '../../core/services/common.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {
  isEmailVerified = false;
  isOtpAuthenticated = false;
  isSetPassword = false;
  passwordMatch = true;
  isSubmitted: boolean = false;
  public forgetPasswordForm!: FormGroup;
  public setPasswordForm!: FormGroup;
  ifContactExist: any;
  otpGenerated = false;
  showOtpNotification = false;
  wrongOtp = false;
  otp: any;
  encryptedContactGuid: any;
  isDeactivated = false;
  constructor(private loginService: LoginService, private route: Router, public formBuilder: FormBuilder,
    private storageService: StorageService, private activateRoute: ActivatedRoute,
    private assessmentService: AssessmentService, private commonService: CommonService) { }

  ngOnInit(): void {
    let otpAuthStatus = this.loginService.getIfOtpAuthenticated();
    if (otpAuthStatus) {
      this.setPasswordForm = this.formBuilder.group({
        // password: ['', [Validators.required, Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{7,}')]],
        password: ['', [Validators.required, Validators.pattern('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[~!@#\$%\^\&\*\{\(\)\+\[=._-\`\,\;\?<\}>\/\:\'\"\|])(?!.* )(?!.*\\\\)(?!.*\]).{8,15}$')]],
        confirmPassword: ['', [Validators.required]]
      });
      this.isOtpAuthenticated = true;
      this.isEmailVerified = true;
    } else {
      this.forgetPasswordForm = this.formBuilder.group({
        email: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]]
      });
    }
  }


  verifyUser() {
    this.isSubmitted = true;
    if (this.forgetPasswordForm.valid) {
      const rqstBody = {
        userId: this.forgetPasswordForm.value.email,
      }
      this.loginService.checkIfContactExists(rqstBody).subscribe((res: any) => {
        let decryptedData = this.commonService.decryptUsingAES256(res?.data);
        //console.log('get user data if contact exists: ', decryptedData);
        if (decryptedData?.isContactExist) {
          if (!decryptedData?.isActivate) {
            this.ifContactExist = true;
            this.isDeactivated = true;
          } else {
            this.ifContactExist = true;
            this.isEmailVerified = true;
            this.isOtpAuthenticated = false;
            let contactguid = decryptedData.contactguid;
            //console.log('has to encrypt: ',contactguid);
            this.encryptedContactGuid = this.commonService.encryptUsingAES256(contactguid);
            this.loginService.setContactguid(this.encryptedContactGuid);
            this.loginService.setContactEmailId(this.forgetPasswordForm.value.email);
            this.route.navigate(['verify-otp']);
          }
        } else {
          this.ifContactExist = false;
          this.isEmailVerified = false;
        }
      });
    }
  }

  clearPasswordErr(event: any) {
    this.passwordMatch = true;
    // if (event.key == '\\' || event.which == 220 || event.key == ';' || event.which == 186) {
    //   event.preventDefault();
    //   return;
    // }
  }


  removeContactExistErrMsg() {
    this.ifContactExist = true;
  }

  setPassword() {
    this.isSubmitted = true;
    this.passwordMatch = this.setPasswordForm.value.password === this.setPasswordForm.value.confirmPassword;
    if (this.setPasswordForm.valid && this.passwordMatch) {
      const setPasswordData = {
        email: this.loginService.getContactEmailId(),
        password: this.setPasswordForm.value.password,
        contactguid: this.commonService.decryptUsingAES256(this.loginService.getContactguid())
      }
      this.loginService.setPassword(setPasswordData).subscribe((data: any) => {
        //console.log('is set password User data: ',data);
        let decryptedData = this.commonService.decryptUsingAES256(data?.data);
        if (decryptedData?.isPasswordChanged === true) {
          this.isSubmitted = false;
          this.isSetPassword = true;
          this.setPasswordForm.reset();
          setTimeout(() => {
            this.route.navigate(['login']);
          }, 10000)

        } else if (data?.error) {

        }
      });
    }
  }


}
